import styled from "styled-components";
import { Link } from "react-router-dom";
import { HeatMapGrid } from "react-grid-heatmap";
import { primaryColor, primaryColorHover } from "../../../../../../config/constants";

export const MainDiv = styled.div`
  margin: 0 auto 16px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background-color: #fff;
`;
export const Header = styled.div`
  padding: 0 0 0 16px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  position: relative;
  z-index: 1;
`;
export const Title = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 600;
`;
export const OpenButton = styled.button`
  width: 33px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
  border-left: 2px solid rgb(230, 230, 230);
  background: transparent;
  position: absolute;
  right: 0;
  cursor: pointer;
`;
export const OpenButtonImg = styled.img`
  width: 15px;
  height: 15px;
`;

export const PlotDiv = styled.div`
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const AxisY = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  transform: rotate(-90deg);
`;
export const HeatMapContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
`;
export const HeatMapWithSessionsContainer = styled.div`
  display: flex;
  gap: 10px;
`;
export const HeatMapStyled = styled(HeatMapGrid)``;
export const AxisX = styled.p`
  margin-left: 180px;
  color: #000;
  font-size: 14px;
  font-weight: 400;
`;
export const SessionsContainer = styled.div`
  width: fit-content;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
export const SessionsAligner = styled.div`
  width: 45px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const ReportsLink = styled(Link)`
  width: 22px;
  height: 22px;
  background-color: ${({ sessions }) => (sessions > 0 ? primaryColor : "#808080")};
  border-radius: 4px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: 30px;
    height: 30px;
  }
`;
export const ReportsImg = styled.img`
  width: 70%;
  height: 70%;
`;
export const SessionsNumber = styled.p`
  width: 15px;
  height: 27px;
  color: #000;
  font-size: 13px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
`;
